(function() {
    'use strict';

    angular.module('app.cantidadesDestajo', []);
})();
